import Swiper from 'swiper/core';
import { Navigation } from 'swiper/modules';

function initGallerySliders() {
  const containers = document.querySelectorAll('.js-slider-container');

  if (!containers.length) return;

  containers.forEach((container) => {
    const slider = container.querySelector('.js-gallery-slider');
    if (!slider) return;

    const sliderArrows = container.querySelector('.c-arrows');
    let navArrows = false;

    if (sliderArrows) {
      const next = sliderArrows.querySelector('.js-next');
      const prev = sliderArrows.querySelector('.js-prev');

      navArrows = {
        nextEl: next,
        prevEl: prev,
      };
    }

    new Swiper(slider, {
      modules: [Navigation],
      slidesPerView: 1,
      grabCursor: true,
      loop: true,
      navigation: navArrows,
    });
  });
}

function initCustomNavigation() {
  const navButtons = Array.from(document.querySelectorAll('.l-destinations__nav-btn'));
  const sections = Array.from(document.querySelectorAll('.l-destinations .u-container[data-term]'));
  if (!navButtons.length || !sections.length) return;

  // Мапы: slug -> button / section
  const btnBySlug = new Map(navButtons.map((b) => [b.dataset.target, b]));
  const sectionBySlug = new Map(sections.map((s) => [s.dataset.term, s]));

  const setActive = (slug) => {
    navButtons.forEach((b) => b.classList.remove('is-active'));
    const btn = btnBySlug.get(slug);
    if (btn) btn.classList.add('is-active');
  };

  // Клик по навигации: скроллим к нужной секции и сразу активируем кнопку
  navButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const slug = btn.dataset.target;
      const targetSection = sectionBySlug.get(slug);
      if (targetSection) {
        const top = targetSection.getBoundingClientRect().top + window.pageYOffset; // поправь offset при необходимости
        window.scrollTo({ top, behavior: 'smooth' });
        // setActive(slug);
      }
    });
  });

  // Вычисляем, какая секция ближе к центру вьюпорта
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const viewportMiddle = window.scrollY + window.innerHeight - 100;
      let currentSlug = null;
      let bestDist = Infinity;

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        // учитываем только видимые (пересекающиеся) секции
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

        const sectionMiddle = window.scrollY + rect.top + rect.height / 2;
        const dist = Math.abs(sectionMiddle - viewportMiddle);
        if (dist < bestDist) {
          bestDist = dist;
          currentSlug = section.dataset.term;
        }
      });

      if (currentSlug) setActive(currentSlug);
      ticking = false;
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Инициализируем активную кнопку при загрузке
  onScroll();
}

// function initCustomNavigation() {
//   const navButtons = document.querySelectorAll('.l-destinations__nav-btn');
//   const sections = document.querySelectorAll('.l-destinations .u-container');

//   if (!navButtons.length || !sections.length) return;

//   navButtons.forEach((btn) => {
//     btn.addEventListener('click', () => {
//       const targetSlug = btn.getAttribute('data-target');
//       const targetSection = document.querySelector(`.u-container[data-term="${targetSlug}"]`);
//       if (targetSection) {
//         const top = targetSection.getBoundingClientRect().top + window.pageYOffset - 50;
//         window.scrollTo({ top, behavior: 'smooth' });
//       }
//     });
//   });

//   window.addEventListener('scroll', () => {
//     sections.forEach((section, i) => {
//       const rect = section.getBoundingClientRect();
//       const btn = navButtons[i];
//       if (rect.top < window.innerHeight / 2 && rect.bottom > window.innerHeight / 2) {
//         navButtons.forEach((b) => b.classList.remove('is-active'));
//         if (btn) btn.classList.add('is-active');
//       }
//     });
//   });
// }

document.addEventListener('DOMContentLoaded', () => {
  initGallerySliders();
  initCustomNavigation();
});

// if (window.acf?.addAction) {
//   const rerender = ($el) => {
//     initGallerySliders($el[0] || $el);
//     initCustomNavigation($el[0] || $el);
//   };
//   window.acf.addAction('render_block_preview', rerender);
//   window.acf.addAction('render_block_preview_complete', rerender);
// }
